import {Box, Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid';

type ChallenggeItemTemplateType = {
  showButton?: boolean;
};

const ChallenggeItemTemplate = ({
  showButton = true,
}: ChallenggeItemTemplateType) => (
  <Grid
    container
    height={135}
    mb={1}
    borderRadius={'14px'}
    sx={{backgroundColor: 'background.paper', padding: 2}}>
    {/* Left Content */}
    <Grid item xs={8.5} container direction="column" justifyContent="center">
      <Grid>
        {/* Title and Badge */}
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="text" height={20} width="40%" />
          <Skeleton variant="rounded" height={18} width={30} />
        </Box>

        {/* Time and XP */}
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="text" height={20} width={40} />
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" height={20} width={40} />
          <Skeleton variant="circular" width={20} height={20} />
        </Box>

        {/* Entry & Rewards */}
        <Box display="flex" gap={2}>
          <Skeleton variant="text" height={20} width={60} />
          <Skeleton variant="text" height={20} width={80} />
        </Box>
      </Grid>
      {/* Button */}
      {showButton && <Skeleton variant="rounded" width={100} height={36} />}
    </Grid>

    {/* Right Character Image */}
    <Grid item xs={3.5} container alignItems="center" justifyContent="center">
      <Skeleton variant="rounded" width={80} height={80} />
    </Grid>
  </Grid>
);

export default ChallenggeItemTemplate;
